export enum FromStringToTokenError {
  FractionalMoreThan8Decimals,
  InvalidFormat,
  FractionalTooManyDecimals,
}
